import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { media } from './fixtures/media';
import { mediaPlaceholderSvg } from './fixtures/media-placeholder';
import {
  createPresignedUpload,
  MOCK_BUCKET_HOST,
  MOCK_CDN_HOST,
} from './fixtures/presigned-upload';
import { createPresignedUrls } from './fixtures/presigned-urls';

export const uploadMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-media/clients/:clientId/media`,
    fn,
  );

/**
 * The batch presigned endpoint. Still used by the bulk menu image upload, which
 * builds its own keys and learns its read urls from the menu api afterwards.
 */
export const getPresignedUrlsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-media/presignedurls/client`,
    fn,
  );

/** One file, and the read url comes back with the signed PUT. */
export const getPresignedUploadMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-media/presignedupload/client`,
    fn,
  );

export const s3PresignedPutMock = fn => rest.put(`${MOCK_BUCKET_HOST}/*`, fn);

/** The distribution. Reads only — nothing is ever written here. */
export const cloudfrontGetMock = fn => rest.get(`${MOCK_CDN_HOST}/*`, fn);

export const handlers = () => [
  uploadMock((_req, res, ctx) => {
    return res(ctx.json(media));
  }),

  getPresignedUrlsMock((req, res, ctx) => {
    return res(ctx.json(createPresignedUrls(req.body.keys)));
  }),

  getPresignedUploadMock((req, res, ctx) =>
    res(ctx.json(createPresignedUpload(req.body, req.headers.get('clientid')))),
  ),

  s3PresignedPutMock((_req, res, ctx) => {
    /*
     * The body goes nowhere, and cannot: the generated worker reads every
     * request as text, so binary is already UTF-8 mangled by the time a handler
     * runs. The delay is here because an upload that returns instantly hides
     * every progress and cancellation path.
     */
    return res(ctx.status(200), ctx.delay(3000));
  }),

  cloudfrontGetMock((req, res, ctx) => {
    // Everything under the distribution resolves, so a preview always paints.
    const key = req.url.pathname.replace(/^\//, '');

    return res(
      ctx.set('Content-Type', 'image/svg+xml'),
      ctx.set('Cache-Control', 'public, max-age=31536000, immutable'),
      ctx.body(mediaPlaceholderSvg(decodeURIComponent(key))),
    );
  }),
];
